import { styled } from '@mui/material/styles';
import { TableCellTypography } from '../table-cell-typography';

export const Wrapper = styled(TableCellTypography)`
  font-weight: 400;
`;
